module.exports = __webpack_public_path__ + "img/eq-avenger-guard.0a1a05a4.png";